export const CAD_AVL_MODAL_IDS = Object.freeze({
    CREATE_ASSIGNMENT: 'cadAvlCreateAssignment',
    EDIT_ASSIGNMENT: 'cadAvlEditAssignment',
    DELETE_ASSIGNMENT: 'cadAvlDeleteAssignment',
});
